// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ISO = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ISO = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ISO = _exports.ISO = function ISO(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("path", {
      stroke: "currentColor",
      strokeLinejoin: "round",
      strokeWidth: 1.5,
      d: "M16.927 8.496v8.43a2.08 2.08 0 0 1-2.078 2.079H5.152a2.08 2.08 0 0 1-2.078-2.078V3.074A2.08 2.08 0 0 1 5.152.996h4.275c.367 0 .72.146.98.406l6.114 6.115c.26.26.406.612.406.98Z"
    }), /*#__PURE__*/React.createElement("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5,
      d: "M10 1.342v5.195a1.385 1.385 0 0 0 1.385 1.385h5.195"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M6.879 12.05H6v3.636h.879zM9.396 13.14h.842C10.23 12.46 9.689 12 8.844 12c-.83 0-1.43.453-1.424 1.13-.002.551.385.862 1.014 1.006l.38.089c.4.092.579.2.582.405-.003.222-.211.376-.564.376-.39 0-.645-.181-.664-.53h-.842c.01.85.602 1.256 1.516 1.256.906 0 1.442-.41 1.446-1.1-.004-.581-.396-.936-1.114-1.094l-.312-.071c-.33-.071-.54-.181-.533-.398.002-.199.172-.343.513-.343.343 0 .531.155.554.414M14.164 13.868c0-1.202-.76-1.868-1.737-1.868-.98 0-1.735.666-1.735 1.868 0 1.197.755 1.868 1.735 1.868.977 0 1.737-.666 1.737-1.868m-.899 0c0 .712-.312 1.097-.838 1.097-.524 0-.838-.385-.838-1.097s.314-1.097.838-1.097c.526 0 .838.385.838 1.097"
    }));
  };
});
